import store from './../../store'
import Vue from 'vue'
// http://localhost:8080/callback?token=1231231232131
const roleAcces = (router) => {

    router.beforeEach((to, from, next) => {

        if (to.meta.hasAcces) {
            var allowed

            to.meta.hasAcces.forEach(role => {
                if (!store.state.users.me) {
                    store.dispatch('users/getMyProfile', Vue.prototype.$ApiClient).then((res) => {

                    });
                }
                allowed = store.state.users.me[role]
            })
            if (allowed) {
                next();
            } else {
                next(from.path);
            }
        } else {
            next();
        }
    })
}

export default roleAcces;